import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { FONT, FONT_BOLD } from '../variables';

export async function fetchWebFont(pdf: PDFDocument) {
	const resp = await fetch('/fonts/HankenGrotesk-Regular.ttf');
	const buffer = await resp.arrayBuffer();
	pdf.registerFont(FONT, buffer);

	const respB = await fetch('/fonts/HankenGrotesk-Bold.ttf');
	const bufferB = await respB.arrayBuffer();
	pdf.registerFont(FONT_BOLD, bufferB);
}
